export default __webpack_public_path__ + "static/media/Technical Textiles.5733b53e.jpg";